export class CustomDesignPage  {
    ID: number;
    Name: string;
    ObjectID: number;
    ObjectName: string;
    ModuleID: number;
    ModuleName: string;
    BasePage: boolean;
    FormData: string;
    AddedOn: Date;
    AddedBy: number;
    LastUpOn: Date;
    LastUpBy: number;
    DelStatus: boolean;
    Active: boolean;
    Version: number;
    DesignPageID: number;
    BaseVersion: number;
    ObjectTypeID: number;
    Description: string;
    HasDetailRows: boolean;

    AddedByName: string;
    LastUpByName: string;
   }